export enum Applications {
  EASYWEBINAR = 'EASYWEBINAR',
  EASYCRM = 'EASYCRM',
}

export enum Roles {
  ADMIN = 'ADMIN',
  //MANAGER = 'MANAGER',
  USER = 'USER',
  //NONE= 'NONE',
}